import React, { useEffect, useRef, useState } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import moment from "moment";
import MySelect from "./MySelect";
import { default as ReactSelect, components } from "react-select";
import makeAnimated from "react-select/animated";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { BiLeftArrowAlt, BiSolidHourglass } from "react-icons/bi";
import { useDispatch, useSelector } from "react-redux";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { MdDescription } from "react-icons/md";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import InfoIcon from "@mui/icons-material/Info";
import { Select, MenuItem, OutlinedInput } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import {
  getTeachingTaskDetail,
  downloadstudentdetail,
  downloadsubmissions, getTeachingView
} from "../../redux/actions/teaching";
import ModalRespond from "../../components/Modal/ModalRespond";
import axios from "axios";
import {
  getProfilePic,
  addAttribute,
  tokenAuthorize,
} from "../../components/Helpers/Common";
import {
  ActiveIconColor,
  ActiveTopIconColor,
  BgBlue,
  BgBlueNew,
  BgPostButton,
  ButtonCommonDelete,
  ButtonCommonTopNew,
  Card,
  DivBadge,
  SearchInput,
  TextBlack,
  TextGray,
} from "../Theme";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import IosShareIcon from "@mui/icons-material/IosShare";
import NotificationsOffIcon from "@mui/icons-material/NotificationsOff";
import Swal from "sweetalert2";
import { apiUrl, getUrl, serverUrl } from "../../../src/components/Helpers/Config";
import ModalStudentExport from "../../components/Modal/ModalStudentExport";
import { staticFiles } from "../../components/Helpers/Static";
import { FaSearch } from "react-icons/fa";
import ReflectionCards from "../../components/reflectionCards";
import ButtonBlue from "../../components/Button/ButtonBlue";
import { makeStyles } from "@material-ui/core";
import ButtonCommon from "../../components/Button/ButtonCommon";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import noprofile from "../../common/images-new/no-profile-pic.png";
import Button from "../../components/Button/Button";
import $ from "jquery";
import ProfileImage from "./Profile";
import SearchBar from "../../components/Searchbar";
import { GET_TEACHING_TASK_LIST_DETAIL, GET_TEACHING_DETAILS } from "../../redux/actions";
import { GET_THEME_LOADER } from "../../redux/actions/auth";
const noProfile = noprofile;

var dropdownOption = [
  { label: "Oldest", value: "asc" },
  { label: "Newest", value: "desc" },
];

const useStyles = makeStyles((theme) => ({
  arrow: {
    "&:before": {
      border: "1px solid #E6E8ED",
    },
    color: theme.palette.common.white,
    marginRight: 50,
  },
  tooltip: {
    backgroundColor: theme.palette.common.white,
    border: "1px solid #E6E8ED",
    color: "#4A4A4A",
    fontSize: 17,
    padding: 7,
    borderRadius: 10,
  },
}));

export default function Detail(props) {
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const classes = useStyles();
  const Option = (props) => {
    return (
      <components.Option
        {...props}
        className="flex items-center gap-2 cursor-pointer"
      >
        <input
          type="checkbox"
          checked={props.isSelected}
          onChange={() => null}
        />{" "}
        <label className="ml-1">{props.label}</label>
      </components.Option>
    );
  };

  const animatedComponents = makeAnimated();

  const MoreSelectedBadge = ({ items }) => {
    const style = {
      fontSize: "13px",
      padding: "3px",
      order: 99,
    };

    const title = items.join(", ");
    const length = items.length;
    var label = "";
    if (length - 1 === taskOptions.length) {
      label = "All tasks selected";
    } else {
      label = `${length} task${length !== 1 ? "s" : ""} selected`;
    }

    return (
      <div className="greyColor" style={style} title={title}>
        {label}
      </div>
    );
  };

  const MultiValue = ({ index, getValue, ...props }) => {
    const overflow = getValue().map((x) => x.label);
    return index === 0 ? <MoreSelectedBadge items={overflow} /> : null;
  };

  const id = props.match.params.id;
  const data = useSelector((state) => state.teaching.taskListDetail);
  const isDefaultTheme = useSelector((state) => state.auth.isDefaultTheme);
  const isDetailsView = useSelector((state) => state.teaching.isDetailsView);
  const postRefs = useRef({});


  useEffect(() => {
    dispatch({ type: GET_THEME_LOADER, payload: true });
    //localStorage.setItem("themeLoader",true);
    if (id) {
      axios
        .get(serverUrl.Teaching + `/${id}`)
        .then((resp) => {
          if (resp.status === 200) {
            dispatch({
              type: GET_TEACHING_TASK_LIST_DETAIL,
              payload: resp.data,
            });
          }
          //localStorage.setItem("themeLoader",false);
          dispatch({ type: GET_THEME_LOADER, payload: false });
        })
        .catch((error) => {
          tokenAuthorize(error?.response?.status);
          console.log(error);
          //localStorage.setItem("themeLoader",false);
          dispatch({ type: GET_THEME_LOADER, payload: false });
        });
      // dispatch(getTeachingTaskDetail(id));
    }
  }, [id]);
  const userTheme = useSelector((state) => state.auth.theme);
  const [showRespond, setShowRespond] = useState(false);
  const [showDesc, setShowDesc] = useState(true);
  const [taskOptions, setTaskOptions] = useState([]);
  const [optionSelected, setOptionSelected] = useState([]);
  const [submissions, setSubmissions] = useState([]);
  const [userId, setUserId] = useState(null);
  const [currentComment, setCurrentComment] = useState(null);
  const [searchField, setSearchField] = useState("");
  const [postSearchFiled, setPostSearchField] = useState("");
  const [filteredSubmission, setFilteredSubmission] = useState([]);
  const [showExport, setShowExport] = useState(false);
  const [sortField, setSortField] = useState("desc");
  const [showResponse, setShowResponse] = useState(false);
  const [currentPosts, setCurrentPosts] = useState(null);
  const [currentFiles, setCurrentFiles] = useState([]);

  // Teaching Task Start

  const [taskId, settaskId] = useState(0);
  const [taskData, settaskData] = useState(false);
  const [filteredPost, setFilteredPost] = useState([]);
  const [searchedPost, setSearchedPost] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [searchFieldTask, setSearchFieldTask] = useState("");
  const [sortFieldTask, setSortFieldTask] = useState("desc");
  const [loading, setLoading] = useState(false);
  const [showMore, setshowMore] = useState(false);
  const [showMoreFile, setshowMoreFile] = useState(false);
  const [sorting, setSorting] = useState("asc");
  const [width, setwidth] = useState(window.innerWidth);
  const [isShow, setisShow] = useState(false);

  useEffect(() => {
    axios
      .get(serverUrl.showcaseExportTutor)
      .then((res) => {
        if (res.status === 200) {
          setisShow(res?.data);
        }
      })
      .catch((err) => {
        tokenAuthorize(err?.response?.status);
        console.log(err);
      });
  }, [id]);

  useEffect(() => {
    if (isDetailsView) {
      settaskData(true);
      handleTaskData(isDetailsView);
    }
  }, []);
  useEffect(() => {
    const changeWidth = () => {
      setwidth(window.innerWidth);
    };
    var startProductBarPos = -1;
    function handleScroll() {
      const bar = document.getElementById("dpTeachingSticky");
      if (!bar) return;

      if (startProductBarPos < 0) {
        startProductBarPos = findPosY(bar);
      }

      if (window.pageYOffset + 140 > startProductBarPos) {
        $("#dpTeachingSticky").addClass("dpteaching-sticky-height");
      } else {
        $("#dpTeachingSticky").removeClass("dpteaching-sticky-height");
      }
    }

    // Attach listener
    window.addEventListener("scroll", handleScroll);

    window.addEventListener("resize", changeWidth);
    return () => {
      window.removeEventListener("resize", changeWidth);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const findPosY = (obj) => {
    var curtop = 0;
    if (typeof obj?.offsetParent != "undefined" && obj.offsetParent) {
      while (obj?.offsetParent) {
        curtop += obj?.offsetTop;
        obj = obj?.offsetParent;
      }
      curtop += obj?.offsetTop;
    } else if (obj?.y) curtop += obj?.y;
    return curtop;
  };

  //attachments
  const [userName, setuserName] = useState("");
  const [userTaskId, setuserTaskId] = useState("");
  //file
  const [userNameFile, setuserNameFile] = useState("");
  const [userTaskIdFile, setuserTaskIdFile] = useState("");
  const [tutorGuid, setTutorGuid] = useState("");
  const [tutorProfile, setTutorProfile] = useState(null);
  const [tutorName, setTutorName] = useState("");

  useEffect(() => {
    axios
      .get(serverUrl.Task + `/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setTutorGuid(res.data?.tutor_guid);
          setTutorProfile(res.data?.tutor_profile);
          setTutorName(res.data?.tutor_name);
        }
      })
      .catch((error) => {
        tokenAuthorize(error?.response?.status);
      });
  }, [id]);

  const Loading = ({ active }) => {
    let style = active ? "w-10 h-10 mx-20" : "hidden w-10 h-10";
    return <img src={staticFiles.loading} alt="loading..." className={style} />;
  };

  const getTasks = (id, data) => {
    setLoading(true);
    let apiurl =
      apiUrl +
      "task/teaching/posts/" +
      id +
      "?sort=" +
      data.sort +
      "&offset=" +
      data.offset;
    axios
      .get(apiurl)
      .then((resp) => {
        if (resp.status == 200) {
          if (resp?.data?.posts?.length > 0) {
            setFilteredPost(resp.data?.posts || []);
            settaskData(true);
            setLoading(false);
            window.scrollTo(0, 0);
          } else {
            setLoading(false);
            Swal.fire({
              title: "Summary View",
              text: "No student responses found",
              icon: "info",
            }).then((result) => {
              if (result.isConfirmed) {
                // goBack()
              }
            });
          }
        } else {
          setLoading(false);
          Swal.fire({
            title: "Summary View",
            text: "No student responses found",
            icon: "info",
          }).then((result) => {
            if (result.isConfirmed) {
              // goBack()
            }
          });
        }
      })
      .catch((err) => {
        tokenAuthorize(err?.response?.status);
        setLoading(false);
        console.log(err);
        Swal.fire({
          title: "Summary View",
          text: "No student responses found",
          icon: "info",
        }).then((result) => {
          if (result.isConfirmed) {
            // goBack()
          }
        });
      });
  };

  const onChangeSort = (e) => {
    setSortFieldTask(e.target.value);
    const data = {
      sort: e.target.value,
      offset: 0,
    };
    getTasks(taskId, data);
  };

  // const handleChangeTask = (e) => {
  //   setSearchField(e.target.value);
  //   let data = [];
  //   filteredPost.map((t) =>
  //     t?.fullname?.toLowerCase()?.includes(e.target.value?.toLowerCase())
  //       ? data.push(t)
  //       : ""
  //   );
  //   setSearchedPost(data);
  // };

  useEffect(() => {
    let data = [];
    filteredPost.map((t) =>
      t?.fullname?.toLowerCase()?.includes(postSearchFiled?.toLowerCase())
        ? data.push(t)
        : ""
    );
    setSearchedPost(data);
  }, [postSearchFiled]);

  const goBack = () => {
    settaskData(false);
  };

  const loadMorePost = () => {
    setLoading(true);
    const offset = filteredPost ? filteredPost.length : 0;
    axios
      .get(
        apiUrl +
        "task/teaching/posts/" +
        taskId +
        "?sort=" +
        sortField +
        "&offset=" +
        offset
      )
      .then((resp) => {
        if (resp.status === 200) {
          const feedPosts = resp.data.posts;
          if (feedPosts.length > 0) {
            feedPosts?.forEach((item) => {
              setFilteredPost((prev) => [...prev, item]);
            });
          } else {
            setHasMore(false);
          }
        }
        setLoading(false);
      })
      .catch((err) => {
        tokenAuthorize(err?.response?.status);
        console.log(err);
        setLoading(false);
      });
  };

  // Teaching Task End

  const handleShowRespond = (id, comment) => {
    setShowRespond(true);
    setUserId(id);
    setCurrentComment(comment);
  };

  const handleChange = (selected) => {
    if (selected) {
      const taskId = taskOptions.map((task) => task.value);
      const sortedData = selected.sort(
        (a, b) => taskId.indexOf(a.value) - taskId.indexOf(b.value)
      );
      setOptionSelected(sortedData);
    } else {
      let value = selected !== null ? selected : [];
      setOptionSelected(value);
    }
  };

  useEffect(() => {
    if (data.submissions) {
      const filteredData = data.submissions.filter((taskList) =>
        taskList.user_name
          .toString()
          .toLowerCase()
          .includes(searchField.toLowerCase())
      );
      setSubmissions(filteredData);
    }
    if (data.tasks) {
      let options = [];
      const sortedTask = data.tasks.sort((a, b) => a.task_order - b.task_order);

      sortedTask.forEach((task, idx) => {
        options.push({
          value: task.task_id,
          label: ` ${task.task_name}`,
          // label: `Task ${idx + 1}: ${task.task_name}`,
        });
      });

      setTaskOptions(options);
      setOptionSelected(options);
    }
  }, [data, searchField]);

  const headerRef = useRef(null);
  const bodyRef = useRef(null);

  useEffect(() => {
    const header = headerRef.current;
    const body = bodyRef.current;
    if (!header || !body) return;

    // Sync scroll: when header scrolls, body follows
    const syncBody = () => {
      body.scrollLeft = header.scrollLeft;
    };

    // When body scrolls (e.g., with scrollbar), header follows
    const syncHeader = () => {
      header.scrollLeft = body.scrollLeft;
    };

    header.addEventListener("scroll", syncBody);
    body.addEventListener("scroll", syncHeader);

    return () => {
      header.removeEventListener("scroll", syncBody);
      body.removeEventListener("scroll", syncHeader);
    };
  }, []);

  useEffect(() => {
    if (
      userName === "" &&
      userTaskId === "" &&
      userNameFile === "" &&
      userTaskIdFile === ""
    ) {
      const filteredSubmission = filterSubmission(optionSelected, submissions);
      const filterValues = filteredSubmission.map((values) => {
        const key = Object.keys(values.filteredResponses).map((key) => {
          return key;
        });
        const value = Object.values(values.filteredResponses).map((val) => {
          val["showMore"] = false;
          val["showMoreFile"] = false;
          return val;
        });
        for (let i = 0; i < key.length; i++) {
          values.filteredResponses[key[i]] = value[i];
        }
        return values;
      });
      setFilteredSubmission(filterBy(filterValues));
    }
    if (userName !== "" && userTaskId !== "") {
      const filterValues = filteredSubmission.map((values) => {
        const key = Object.keys(values.filteredResponses).map((key) => {
          return key;
        });

        for (let i = 0; i < key.length; i++) {
          if (key[i].includes(userTaskId) && userName === values.user_name) {
            values.filteredResponses[key[i]].showMore = showMore;
          }
        }
        return values;
      });
      setFilteredSubmission(filterBy(filterValues));
    }
    if (userNameFile !== "" && userTaskIdFile !== "") {
      const filterValues = filteredSubmission.map((values) => {
        const key = Object.keys(values.filteredResponses).map((key) => {
          return key;
        });

        for (let i = 0; i < key.length; i++) {
          if (
            key[i].includes(userTaskIdFile) &&
            userNameFile === values.user_name
          ) {
            values.filteredResponses[key[i]].showMoreFile = showMoreFile;
          }
        }
        return values;
      });
      setFilteredSubmission(filterBy(filterValues));
    }
  }, [
    optionSelected,
    submissions,
    userName,
    userTaskId,
    showMore,
    showMoreFile,
    userNameFile,
    userTaskIdFile,
    sorting,
  ]);

  const filterBy = (values) => {
    if (sorting === "asc") {
      values.sort((a, b) =>
        a.user_name > b.user_name ? 1 : a.user_name < b.user_name ? -1 : 0
      );
      return values;
    }
    if (sorting === "desc") {
      values
        .sort((a, b) =>
          a.user_name > b.user_name ? 1 : a.user_name < b.user_name ? -1 : 0
        )
        .reverse();
      return values;
    }
  };

  const filterSubmission = (optionSelected, submissions) => {
    const optionSelectedIds = (optionSelected || []).map(
      (option) => option.value
    );
    const filteredSubmissions = submissions.map((submission) => {
      const responseKeys = Object.keys(submission.responses);
      const selectedResponseKeys = responseKeys.filter((key) => {
        const keyNumber = parseInt(key);
        return optionSelectedIds.includes(keyNumber);
      });
      const sortedSelectedResponseKeys = selectedResponseKeys.sort(
        (a, b) => parseInt(a) - parseInt(b)
      );
      const filteredResponses = {};

      sortedSelectedResponseKeys.forEach((key) => {
        filteredResponses[key] = submission.responses[key];
      });

      submission.filteredResponses = filteredResponses;

      return submission;
    });
    return filteredSubmissions;
  };

  const handleDownloadZip = () => {
    setShowExport(true);
    // dispatch(downloadsubmissions(id));
  };

  const handleDownloadExcel = () => {
    dispatch(downloadstudentdetail(id));
  };

  const handleNotifications = () => {
    axios
      .put(serverUrl.TeachingNotification + `/${id}`)
      .then((resp) => {
        if (resp.status === 200) {
          Swal.fire({
            title: "Success",
            icon: "success",
            text: "Notifications cleared Successfully",
          }).then((result) => {
            if (result.isConfirmed) {
              filteredSubmission.map(
                (submission, idx) => (submission.notification_count = 0)
              );
              setFilteredSubmission(
                filterSubmission(optionSelected, submissions)
              );
            }
          });
        }
        // else {
        //   Swal.fire({
        //     "title" : "Error",
        //     "icon": "error",
        //     "text" : "Notifications cleared Successfully"
        //   })
        // }
      })
      .catch((err) => {
        tokenAuthorize(err?.response?.status);
        console.log(err);
      });
  };

  const handleTaskData = (id) => {
    setSortFieldTask("desc");
    const data = {
      sort: sortFieldTask,
      offset: 0,
    };
    setPostSearchField("");
    settaskId(id);
    getTasks(id, data);
    dispatch({ type: GET_TEACHING_DETAILS, payload: id });
  };

  const formatModernDate = (isoDate) => {
    const date = new Date(isoDate);
    return date.toLocaleDateString("en-GB", {
      year: "numeric",
      month: "short", // Jan, Feb, Mar, etc.
      day: "numeric", // 1, 2, 3...
    });
  };

  const handleShowResponse = (file, post) => {
    setCurrentFiles(file);
    setCurrentPosts(post);
    setShowResponse(true);
  };
  useEffect(() => {
    const lastPostId = sessionStorage.getItem("lastPostId");
    if (lastPostId && postRefs.current[lastPostId]) {
      setTimeout(() => {
        postRefs.current[lastPostId].scrollIntoView({ behavior: "smooth", block: "start" });
      }, 0);
      sessionStorage.removeItem("lastPostId");
    }
  }, [filteredPost, searchedPost, postSearchFiled]);

  return (
    <>
      {taskData == false ? (
        <div className="px-5 md:px-10 py-5">
          <ModalStudentExport
            show={showExport}
            setShow={setShowExport}
            data={filteredSubmission}
            id={id}
          />
          <ModalRespond
            listId={id}
            userId={userId}
            comment={currentComment}
            handleClose={(refresh) => {
              if (refresh) dispatch(getTeachingTaskDetail(id));
              setShowRespond(false);
            }}
            show={showRespond}
          />
          <div
            className={
              showResponse
                ? "fixed flex items-center justiify-center top-0 left-0 w-full h-full bg-black bg-opacity-60 z999"
                : "hidden"
            }
          >
            <section className="fixed inset-0 flex items-center justify-center ">
              <Card className="bg-white rounded-lg shadow-lg w-full md:w-3/5 p-4 minHeight60 popUpWidth">
                <div className="flex py-2 px-2 justify-between items-center">
                  <div className="w-full font-semibold blackColor ">
                    Response
                  </div>
                  <button
                    className="text-gray-600 hover:text-black text-xl font-bold"
                    onClick={() => {
                      setShowResponse(false);
                    }}
                  >
                    ×
                  </button>
                </div>
                <div className="flex flex-wrap gap-2 px-2 py-2">
                  {currentPosts !== null && currentPosts && (
                    <div className=" space-y-1">
                      {Object.entries(currentPosts).map(
                        ([linkId, linkData], idx) => (
                          <Tooltip
                            key={idx}
                            title={linkData.reflection_title ?? ""}
                            placement="top"
                            arrow
                          >
                            <div
                              className="blueColor cursor-pointer px-2 py-1 rounded-md  flex items-center gap-2"
                              onClick={() => {
                                window.open(
                                  getUrl("/post/") + linkData.reflection_id,
                                  "_blank"
                                );
                                // history.push(
                                //   `/post/${linkData.reflection_id}`,
                                //   {
                                //     src: location.pathname,
                                //     tabId: linkData.reflection_id,
                                //   }
                                // );
                              }}
                            >
                              {/* Number */}
                              <span className="blueColor text-sm w-6 text-right">
                                {idx + 1}.
                              </span>

                              {/* Icon + Title */}
                              <div className="flex items-center gap-1">
                                <MdDescription className="w-5 h-5 blueColor" />
                                <span className="text-sm blueColor hover:underline">
                                  {linkData.reflection_title}
                                </span>
                              </div>
                            </div>
                          </Tooltip>
                        )
                      )}
                    </div>
                  )}

                  {currentFiles && currentFiles !== null && (
                    <div className=" space-y-1">
                      {Object.entries(currentFiles).map(
                        ([linkId, linkData], idx) => {
                          if (linkData == "" || !linkData) {
                            return null;
                          }
                          let itemName = linkData;
                          if (itemName) {
                            const lastSlash = itemName.lastIndexOf("/");

                            if (lastSlash !== -1) {
                              itemName = itemName.substr(
                                lastSlash + 1,
                                itemName.length - lastSlash - 1
                              );
                              itemName = itemName.includes("-")
                                ? itemName.substring(itemName.indexOf("-") + 1)
                                : itemName;
                            }
                          }
                          return (
                            <Tooltip
                              key={idx}
                              title={itemName ?? ""}
                              placement="top"
                              arrow
                            >
                              <a
                                href={linkData}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="blueColor cursor-pointer px-2 py-1 rounded-md hover:no-underline flex items-center gap-2"
                              >
                                {/* Number */}
                                <span className="blueColor text-sm w-6 text-right">
                                  {idx + 1}.
                                </span>

                                {/* Icon + Title */}
                                <div className="flex items-center gap-1">
                                  <MdDescription className="w-5 h-5 blueColor" />
                                  <span className="text-sm blueColor hover:underline">
                                    {itemName}
                                  </span>
                                </div>
                              </a>
                            </Tooltip>
                          );
                        }
                      )}
                    </div>
                  )}
                </div>
              </Card>
            </section>
          </div>
          <div className="flex  items-center mt-2 gap-4">
            {/* <ButtonCommonTopNew
              className={`rounded-lg px-5 py-2 flex items-center w-max cursor-pointer`}
              onClick={() => {
                history.push("/teaching");
              }}
            >
              <BiLeftArrowAlt className="w-5 h-5" />
              <h1 className="text-xs lg:text-sm">Back</h1>
            </ButtonCommonTopNew> */}
            <div
              className={`rounded-lg p-0 flex gap-1 items-center w-max cursor-pointer`}
              onClick={() => {
                dispatch({ type: GET_TEACHING_DETAILS, payload: null });
                history.push("/teaching");
              }}
            >
              <KeyboardBackspaceIcon
                style={{ fontSize: "28px" }}
                className=" primaryIcon"
              />
              <h1 className="text-lg blueColor font-semibold">Back</h1>
            </div>
            <p className=" text-3xl font-bold break-words flex flex-1 justify-center wrap-text">
              {data.list_name}
            </p>
          </div>
          <div className="flex items-center justify-between  gap-5 mt-5 mb-5 flex-wrap">
            {tutorName !== "" && (
              <div className="flex itesm-center gap-5 items-center">
                <div className="flex items-center gap-2">
                  {tutorName !== "" && (
                    <>
                      <Link to={"/profile/" + tutorGuid} target="_blank">
                        <img
                          src={tutorProfile ? tutorProfile : noProfile}
                          className="w-12 h-12 rounded-full object-cover "
                        />
                      </Link>
                      <div className="flex flex-col">
                        {data &&
                          data?.groups?.[0] &&
                          data?.groups?.[0]?.name && (
                            <span className="text-lg font-semibold blackColor">
                              {data?.groups?.[0]?.name ?? ""}
                            </span>
                          )}
                        {tutorName && (
                          <span className="text-md blackColor flex gap-1.5">
                            {tutorName}
                          </span>
                        )}
                      </div>
                    </>
                  )}
                </div>
              </div>
            )}
            <div className="flex items-center gap-5 flex-wrap">
              <div>
                <span className="text-md blackColor flex items-center gap-1">
                  <span className="lightColor">Due on:</span>{" "}
                  {data.list_due ? formatModernDate(data.list_due) : ""}
                </span>
              </div>
              <div>
                <span className="text-md blackColor flex items-center gap-1">
                  <span className="lightColor">Created on:</span>{" "}
                  {data.list_created ? formatModernDate(data.list_created) : ""}
                </span>
              </div>
            </div>
          </div>
          {/* <div className="flex mt-4 text-sm">
            <Link to="/teaching" className="self-end pb-1">
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="black"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15 19l-7-7 7-7"
                />
              </svg>
            </Link>
            <div className="ml-5">
              {data.groups &&
                data.groups.map((list, idx) => (
                  <p key={idx} className="text-sm mb-3">
                    {(idx ? ", " : "") + list.name}
                  </p>
                ))}
              <p className="font-semibold text-lg md:text-2xl mr-8">
                {data.list_name}
              </p>
            </div>
          </div> */}
          {/* <div className="grid my-4 justify-start lg:flex lg:justify-between my-5">
            <div>
              <div className="grid gap-2 md:flex ml-16 mb-5 lg:mb-0">
                {tutorName !== "" && (
                  <div className="flex">
                    <Link to={"/profile/" + tutorGuid} target="_blank">
                      <img
                        src={tutorProfile ? tutorProfile : noProfile}
                        className="w-12 h-12 rounded-full object-cover mr-1"
                      />
                    </Link>
                    <p className="mr-1 ml-2 text-xl text-black  sm:text-xl self-center">
                      {tutorName === undefined ? "" : tutorName}
                    </p>
                  </div>
                )}
                <div className="ml-2 flex self-center gap-1">
                  <svg
                    className="mr-2 self-center "
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.4989 14.6286C10.1268 14.6286 9.76307 14.739 9.45382 14.946C9.14457 15.153 8.90373 15.4471 8.76184 15.7911C8.61994 16.1351 8.58337 16.5135 8.65676 16.8783C8.73016 17.2431 8.91021 17.5779 9.1741 17.8402C9.43799 18.1026 9.77384 18.2807 10.1391 18.352C10.5043 18.4232 10.8825 18.3845 11.2256 18.2406C11.5688 18.0967 11.8615 17.8541 12.0667 17.5437C12.2718 17.2332 12.3802 16.8688 12.378 16.4967C12.3751 16.0003 12.1759 15.5251 11.8238 15.1751C11.4717 14.825 10.9954 14.6285 10.4989 14.6286ZM19.5011 14.6286C19.1285 14.6264 18.7637 14.735 18.453 14.9407C18.1424 15.1463 17.8998 15.4397 17.7562 15.7835C17.6127 16.1273 17.5745 16.506 17.6467 16.8715C17.7188 17.2371 17.898 17.5729 18.1615 17.8363C18.4249 18.0998 18.7608 18.279 19.1263 18.3511C19.4918 18.4233 19.8705 18.3852 20.2143 18.2416C20.5581 18.098 20.8515 17.8555 21.0571 17.5448C21.2628 17.2341 21.3714 16.8693 21.3693 16.4967C21.3664 16.0021 21.1687 15.5286 20.8189 15.1789C20.4692 14.8292 19.9957 14.6314 19.5011 14.6286ZM15 0C12.0333 0 9.13319 0.879735 6.66645 2.52796C4.19972 4.17618 2.27713 6.51886 1.14181 9.25975C0.00649929 12.0006 -0.290551 15.0166 0.288228 17.9264C0.867006 20.8361 2.29562 23.5088 4.39341 25.6066C6.49119 27.7044 9.16394 29.133 12.0737 29.7118C14.9834 30.2906 17.9994 29.9935 20.7403 28.8582C23.4812 27.7229 25.8238 25.8003 27.4721 23.3336C29.1203 20.8668 30 17.9667 30 15C30 11.0218 28.4197 7.20644 25.6066 4.3934C22.7936 1.58035 18.9783 0 15 0ZM15 26.9956C11.8128 26.9956 8.75608 25.7295 6.50237 23.4758C4.24865 21.2221 2.98253 18.1654 2.98253 14.9782C2.98202 14.5476 3.0039 14.1173 3.04808 13.689C6.60866 12.125 9.42971 9.24914 10.925 5.65914C12.3009 7.6191 14.1276 9.21975 16.2513 10.3263C18.375 11.4328 20.7335 12.0128 23.1282 12.0175C24.2644 12.0194 25.397 11.8911 26.504 11.6351C26.8307 12.7343 26.9963 13.8751 26.9956 15.0219C26.9841 18.1977 25.7159 21.2399 23.4681 23.4836C21.2204 25.7272 18.1759 26.9899 15 26.9956Z"
                      fill="#2084D4"
                    />
                  </svg>
                  <TextGray className="mr-1 text-xs text-gray-400 self-center sm:text-xs md:text-base lg:text-base">
                    {submissions ? submissions.length : 0} students
                  </TextGray>
                </div>

                <div className={"ml-1 flex self-center gap-1"}>
                  <div className="w-10 flex flex-wrap content-center justify-center calendar">
                    <p className="text-blue-500 font-semibold pt-2">
                      {moment(data.list_due).date()}
                    </p>
                  </div>
                  <div className="flex">
                    <TextGray className="ml-2 text-xs text-gray-400 self-center sm:text-xs md:text-base lg:text-base">
                      Due on {moment(data.list_due).format("DD/MM/YYYY")}{" "}
                    </TextGray>
                  </div>
                  <TextGray className="ml-2 text-xs text-gray-400 self-center  sm:text-xs md:text-base lg:text-base">
                    Created on {moment(data.list_created).format("DD/MM/YYYY")}
                  </TextGray>
                </div>
              </div>
            </div>
          </div> */}
          {/* <div
            className={width < 1024 ? "grid justify-start" : "flex justify-end"}
          >
            <p className="self-center font-semibold sm:ml-5 text-xs sm:text-base">
              Search Students:
            </p>
            <input
              type="text"
              className="w-56 bg-white border border-gray-300 rounded-md self-center mb-4 sm:mb-0 sm:ml-4 px-2 py-2"
              placeholder="Students name"
              onChange={(e) => setSearchField(e.target.value)}
            />
          </div> */}
          {/* <div className="flex text-gray-500 mb-2">
            <p
              className="font-bold text-black self-center cursor-pointer"
              onClick={() => setShowDesc(!showDesc)}
            >
              Description
            </p>
            <div className="border-t border-gray-300 self-center ml-3 mr-1 w-full" />
            {showDesc ? (
              <svg
                className="w-6 cursor-pointer self-center"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                onClick={() => setShowDesc(false)}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M5 15l7-7 7 7"
                />
              </svg>
            ) : (
              <svg
                className="w-6 cursor-pointer self-center"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                onClick={() => setShowDesc(true)}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            )}
          </div> */}
          <div
            className="text-viewer break-words wrap-text"
            dangerouslySetInnerHTML={{ __html: addAttribute(data.list_desc) }}
          />
          {/* {showDesc ? (
            <div
              className="text-viewer break-words"
              dangerouslySetInnerHTML={{ __html: addAttribute(data.list_desc) }}
            />
          ) : null} */}
          <div className="flex justify-between flex-wrap gap-2 my-5">
            <div className="flex items-center gap-3 flex-wrap">
              <div className="flex items-center">
                <SearchBar
                  setSearchField={setSearchField}
                  placeholder="Search student"
                />
              </div>
              <span
                className="inline-block w-56"
                data-toggle="popover"
                data-trigger="focus"
                data-content="Please selecet account(s)"
              >
                <MySelect
                  isSearchable={false}
                  options={taskOptions}
                  defaultValue={[taskOptions[1]]}
                  isMulti
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  components={{
                    Option,
                    MultiValue,
                    animatedComponents,
                  }}
                  menuPortalTarget={document.body}
                  styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                  placeholder="Task in assignment"
                  onChange={handleChange}
                  allowSelectAll={false}
                  value={optionSelected}
                />
              </span>
            </div>
            <div className="flex items-center gap-3 flex-wrap">
              {filteredSubmission?.filter(
                (r) => parseInt(r.notification_count) > 0
              ).length > 0 && (
                  <ButtonCommonDelete
                    className="rounded-lg text-sm px-4 py-2 flex items-center gap-1 cursor-pointer"
                    onClick={handleNotifications}
                  >
                    <NotificationsOffIcon
                      style={{ fontSize: "20px" }}
                      className="deleteColor"
                    />
                    <span className="flex items-center gap-1">
                      <span>Clear</span>
                      {filteredSubmission.reduce(
                        (sum, item) => sum + parseInt(item.notification_count),
                        0
                      )}
                      <span>Notifications</span>
                    </span>
                  </ButtonCommonDelete>
                )}
              {isShow && (
                <ButtonCommonTopNew
                  onClick={handleDownloadZip}
                  className="rounded-lg text-sm px-4 py-2 flex items-center gap-1 cursor-pointer"
                >
                  <IosShareIcon
                    style={{ fontSize: "18px" }}
                    className="blueColor"
                  />
                  Export Assignments
                </ButtonCommonTopNew>
                // <ButtonCommon
                //   className="rounded-md px-10 py-3 cursor-pointer w-full"
                //   onClick={handleDownloadZip}
                //   title="Export Assignments"
                // ></ButtonCommon>
              )}
              <ButtonCommonTopNew
                onClick={handleDownloadExcel}
                className="rounded-lg text-sm px-4 py-2 flex items-center gap-1 cursor-pointer"
              >
                <FileDownloadIcon
                  style={{ fontSize: "19px" }}
                  className="blueColor"
                />
                Download Class List
              </ButtonCommonTopNew>
              {/* <ButtonCommon
                  buttonStyle="ml-3"
                  className="rounded-md px-10 py-3 cursor-pointer w-full"
                  onClick={handleDownloadExcel}
                  title="Download Class List"
                ></ButtonCommon> */}
            </div>
          </div>
          {/* <BgBlueNew
            style={{ top: "90px" }}
            className="border-bottom-f1 py-4 min-w-max z-50  text-center hidden md:flex rounded-md rounded-b-none dpteaching-sticky sticky top-0"
          >
            <div className="flex sticky top-0">
              <div className="w-56 flex justify-center relative">
                <div>Student</div>
                {sorting === "asc" ? (
                  <div
                    className="cursor-pointer ml-3 mt-1"
                    onClick={() => setSorting("desc")}
                  >
                    <ArrowDropUpIcon className="absolute -top-1 text-size" />
                    {isDefaultTheme == false ? (
                      <ActiveTopIconColor>
                        <ArrowDropDownIcon className="absolute top-1 text-size" />
                      </ActiveTopIconColor>
                    ) : (
                      <ArrowDropDownIcon className="absolute text-blue-500 top-1 text-size" />
                    )}
                  </div>
                ) : (
                  <div
                    className="cursor-pointer ml-3 mt-1"
                    onClick={() => setSorting("asc")}
                  >
                    {isDefaultTheme == false ? (
                      <ActiveTopIconColor>
                        <ArrowDropUpIcon className="absolute -top-1 text-size" />
                      </ActiveTopIconColor>
                    ) : (
                      <ArrowDropDownIcon className="absolute text-blue-500 top-1 text-size" />
                    )}
                    <ArrowDropDownIcon className="absolute top-1  text-size" />
                  </div>
                )}
              </div>
              {optionSelected !== null &&
                optionSelected.length > 0 &&
                optionSelected.map((list, idx) => (
                  <div
                    key={idx}
                    className="w-48"
                    onClick={() => handleTaskData(list.value)}
                  >
                    <Tooltip
                      title={list.label}
                      classes={{
                        arrow: classes.arrow,
                        tooltip: classes.tooltip,
                      }}
                      placement="right"
                      arrow
                    >
                      <span className="cursor-pointer">
                        {list.label?.split(":")[0]}
                      </span>
                    </Tooltip>
                  </div>
                ))}
            </div>
          </BgBlueNew> */}
          <div className="border-right-f1 border-left-f1  rounded-t-md h-auto   mb-4 ">
            <BgBlueNew
              ref={headerRef}
              style={{ top: "88px" }}
              className="border-bottom-f1 sticky top-[90px]  bg-blue-600
             overflow-x-auto scrollbar-hide z-10
             py-4 text-center rounded-md rounded-b-none hidden md:block"
            >
              <div className="flex min-w-max">
                <div
                  className="w-56 cursor-pointer flex justify-center items-center sticky left-0 lightBackGroundColor"
                  onClick={() => setSorting(sorting === "asc" ? "desc" : "asc")}
                >
                  <div>Student</div>
                  {sorting === "asc" ? (
                    <KeyboardArrowUpIcon className="text-white ml-1 cursor-pointer" />
                  ) : (
                    <KeyboardArrowDownIcon className="text-white ml-1 cursor-pointer" />
                  )}
                </div>

                {optionSelected?.map((list, idx) => (
                  <div
                    key={idx}
                    className="w-28"
                    onClick={() => handleTaskData(list.value)}
                  >
                    <span className="cursor-pointer">
                      <Tooltip
                        title={list.label}
                        classes={{
                          arrow: classes.arrow,
                          tooltip: classes.tooltip,
                        }}
                        placement="right"
                        arrow
                      >
                        {list.label?.split(":")[0]}
                      </Tooltip>
                      <Tooltip
                        title={"Click to view summary"}
                        placement="top"
                        arrow
                      >
                        <span>
                          <InfoIcon className="cursor-pointer  ml-1 text-white info-icon-width -mt-2" />
                        </span>
                      </Tooltip>
                    </span>
                  </div>
                ))}

                <div className="w-40 cursor-pointer flex justify-center items-center sticky right-0 lightBackGroundColor ml-auto">
                  Comments
                </div>
              </div>
            </BgBlueNew>

            <div ref={bodyRef} className="overflow-x-auto">
              <div className="min-w-max">
                {filteredSubmission !== null &&
                  filteredSubmission.length > 0 &&
                  filteredSubmission?.map((submission, idx) => (
                    <Card
                      className={`border-bottom-f1 py-3 min-w-max flex`}
                      key={idx}
                    >
                      <div className="md:flex w-full ">
                        <div className="w-full flex justify-center  md:w-56  px-3 sticky left-0 cardBackgroundColor">
                          <div className="flex  items-center  w-full h-full">
                            <ProfileImage user_link={submission.user_link} />
                            <Link
                              to={submission.user_link}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="self-center ml-3 font-semibold nav-navigate"
                            >
                              <ActiveIconColor className="hover:none">
                                {submission.user_name}
                              </ActiveIconColor>
                            </Link>
                            {submission.notification_count != null &&
                              submission.notification_count > 0 && (
                                <>
                                  <div
                                    className="circle-small ml-2 w-max flex flex-shrink-0 items-center justify-center"
                                    style={{
                                      fontSize:
                                        submission.notification_count.toString()
                                          .length > 2
                                          ? "10px"
                                          : "14px",
                                    }}
                                  >
                                    {submission.notification_count}
                                  </div>
                                </>
                              )}
                          </div>
                        </div>
                        {submission.filteredResponses &&
                          optionSelected.map((i, index) =>
                            Object.entries(submission.filteredResponses).map(
                              ([taskId, response], idx) => {
                                if (taskId == i.value.toString())
                                  return (
                                    <div
                                      key={idx}
                                      className="w-full md:w-28 md:px-0 md:py-0 px-4 py-2 gap-3 h-auto md:h-auto flex  justify-start md:justify-center items-center"
                                    >
                                      <div className="md:hidden flex ">
                                        Task {index + 1}{" "}
                                      </div>
                                      <div className="flex flex-col h-auto md:h-full justify-center items-center">
                                        <div className="flex items-center w-full h-full justify-center mb-2">
                                          {response.status == true ? (
                                            (() => {
                                              const hasFileUrl =
                                                Array.isArray(
                                                  response.file_url
                                                ) &&
                                                response.file_url.length > 0 &&
                                                response.file_url.some(
                                                  (f) => f !== null && f !== ""
                                                );

                                              const hasAttachments =
                                                response.attachments &&
                                                Object.keys(
                                                  response.attachments
                                                ).length > 0;

                                              const isClickable =
                                                hasFileUrl || hasAttachments;

                                              return (
                                                <div
                                                  onClick={() => {
                                                    if (isClickable) {
                                                      handleShowResponse(
                                                        response.file_url,
                                                        response.attachments
                                                      );
                                                    }
                                                  }}
                                                  className={`flex md:flex-col flex-row justify-center items-center w-full ${isClickable
                                                    ? "cursor-pointer"
                                                    : "cursor-default"
                                                    }`}
                                                >
                                                  <CheckCircleIcon
                                                    className="w-5 h-5"
                                                    style={{
                                                      color:
                                                        userTheme == "" ||
                                                          userTheme ==
                                                          "default theme"
                                                          ? "#66D692"
                                                          : userTheme?.color2,
                                                    }}
                                                  />

                                                  {response.file_url.filter(
                                                    (data) => data !== null
                                                  ).length > 0 && (
                                                      <span className="flex w-full items-center text-sm greyColor gap-1 ml-1 mt-auto">
                                                        {
                                                          response.file_url.filter(
                                                            (data) =>
                                                              data !== null
                                                          ).length
                                                        }
                                                        <span>Response(s)</span>
                                                      </span>
                                                    )}

                                                  {Object.keys(
                                                    response.attachments
                                                  ).length > 0 && (
                                                      <span className="flex w-full items-center text-sm greyColor gap-1 ml-1">
                                                        {
                                                          Object.keys(
                                                            response.attachments
                                                          ).length
                                                        }
                                                        <span>Response(s)</span>
                                                      </span>
                                                    )}
                                                </div>
                                              );
                                            })()
                                          ) : (
                                            <CheckCircleIcon
                                              // style={{
                                              //   // color:
                                              //   //   isDefaultTheme == false
                                              //   //     ? userTheme?.color2
                                              //   //     : "#F4A300",
                                              //   fontSize: "18px",
                                              // }}
                                              className="w-5 h-5 flex-shrink-0 secondaryIcon"

                                            />
                                          )}
                                        </div>
                                        {/* <div className="grid grid-cols-2 gap-2">
                                        {response.attachments &&
                                          (Object.entries(response.attachments)
                                            .length > 5 ? (
                                            response.showMore === false ? (
                                              <>
                                                {Object.entries(
                                                  response.attachments
                                                ).map(
                                                  ([linkId, linkData], idx) => (
                                                    <>
                                                      <Tooltip
                                                        title={
                                                          linkData.reflection_title ??
                                                          ""
                                                        }
                                                        placement="top"
                                                        arrow
                                                      >
                                                        <DivBadge
                                                          key={idx}
                                                          className={
                                                            idx > 3
                                                              ? "hidden"
                                                              : "flex flex-row items-center rounded-lg px-2 justify-center w-max cursor-pointer"
                                                          }
                                                          onClick={() =>
                                                            history.push(
                                                              `/post/${linkData.reflection_id}`,
                                                              {
                                                                src: location.pathname,
                                                                tabId:
                                                                  linkData.reflection_id,
                                                              }
                                                            )
                                                          }
                                                        >
                                                          <MdDescription className="w-4 h-4 text-white" />
                                                          <span
                                                            rel="noopener noreferrer"
                                                            className="flex text-xs p-1 nav-navigate"
                                                          >
                                                            <div className=" text-white">
                                                              Post {idx + 1}
                                                            </div>
                                                          </span>
                                                        </DivBadge>
                                                      </Tooltip>
                                                    </>
                                                  )
                                                )}
                                                <p
                                                  className="text-sm col-span-2 blueColor flex justify-center cursor-pointer"
                                                  onClick={() => {
                                                    setshowMore(true);
                                                    setuserName(
                                                      submission.user_name
                                                    );
                                                    setuserTaskId(taskId);
                                                  }}
                                                >
                                                  More
                                                </p>
                                              </>
                                            ) : (
                                              <>
                                                {Object.entries(
                                                  response.attachments
                                                ).map(
                                                  ([linkId, linkData], idx) => (
                                                    <Tooltip
                                                      title={
                                                        linkData.reflection_title ??
                                                        ""
                                                      }
                                                      placement="top"
                                                      arrow
                                                    >
                                                      <DivBadge
                                                        key={idx}
                                                        className="flex flex-row items-center rounded-lg px-2 justify-center w-max cursor-pointer"
                                                        onClick={() =>
                                                          history.push(
                                                            `/post/${linkData.reflection_id}`,
                                                            {
                                                              src: location.pathname,
                                                              tabId:
                                                                linkData.reflection_id,
                                                            }
                                                          )
                                                        }
                                                      >
                                                        <MdDescription className="w-4 h-4 text-white" />
                                                        <span
                                                          rel="noopener noreferrer"
                                                          className="flex text-xs p-1 nav-navigate"
                                                        >
                                                          <div className=" text-white">
                                                            Post {idx + 1}
                                                          </div>
                                                        </span>
                                                      </DivBadge>
                                                    </Tooltip>
                                                  )
                                                )}
                                                <p
                                                  className="text-sm col-span-2 blueColor flex justify-center cursor-pointer"
                                                  onClick={() => {
                                                    setshowMore(false);
                                                    setuserName(
                                                      submission.user_name
                                                    );
                                                    setuserTaskId(taskId);
                                                  }}
                                                >
                                                  Less
                                                </p>
                                              </>
                                            )
                                          ) : (
                                            Object.entries(
                                              response.attachments
                                            ).map(([linkId, linkData], idx) => (
                                              <Tooltip
                                                title={
                                                  linkData.reflection_title ??
                                                  ""
                                                }
                                                placement="top"
                                                arrow
                                              >
                                                <DivBadge
                                                  key={idx}
                                                  className="flex flex-row items-center rounded-lg px-2 justify-center w-max cursor-pointer"
                                                  onClick={() =>
                                                    history.push(
                                                      `/post/${linkData.reflection_id}`,
                                                      {
                                                        src: location.pathname,
                                                        tabId:
                                                          linkData.reflection_id,
                                                      }
                                                    )
                                                  }
                                                >
                                                  <MdDescription className="w-4 h-4 text-white" />
                                                  <span
                                                    rel="noopener noreferrer"
                                                    className="flex text-xs p-1 nav-navigate"
                                                  >
                                                    <div className=" text-white">
                                                      Post {idx + 1}
                                                    </div>
                                                  </span>
                                                </DivBadge>
                                              </Tooltip>
                                            ))
                                          ))}

                                        {response.file_url &&
                                          (response.file_url.filter(
                                            (val) => val !== null
                                          ).length > 5 ? (
                                            response.showMoreFile === false ? (
                                              <>
                                                {Object.entries(
                                                  response.file_url
                                                ).map(
                                                  ([linkId, linkData], idx) => {
                                                    if (
                                                      linkData == "" ||
                                                      !linkData
                                                    ) {
                                                      return null;
                                                    }
                                                    let itemName = linkData;
                                                    if (itemName) {
                                                      const lastSlash =
                                                        itemName.lastIndexOf(
                                                          "/"
                                                        );

                                                      if (lastSlash !== -1) {
                                                        itemName =
                                                          itemName.substr(
                                                            lastSlash + 1,
                                                            itemName.length -
                                                              lastSlash -
                                                              1
                                                          );
                                                        itemName =
                                                          itemName.includes("-")
                                                            ? itemName.substring(
                                                                itemName.indexOf(
                                                                  "-"
                                                                ) + 1
                                                              )
                                                            : itemName;
                                                      }
                                                    }
                                                    return (
                                                      <Tooltip
                                                        title={itemName ?? ""}
                                                        placement="top"
                                                        arrow
                                                      >
                                                        <DivBadge
                                                          key={idx}
                                                          className={
                                                            idx > 3
                                                              ? "hidden"
                                                              : "flex flex-row items-center rounded-lg px-2 justify-center w-max cursor-pointer"
                                                          }
                                                        >
                                                          <MdDescription className="w-4 h-4 text-white" />
                                                          <a
                                                            href={linkData}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="flex text-xs p-1 nav-navigate"
                                                          >
                                                            <div className=" text-white">
                                                              File {idx + 1}
                                                            </div>
                                                          </a>
                                                        </DivBadge>
                                                      </Tooltip>
                                                    );
                                                  }
                                                )}
                                                <p
                                                  className="text-sm col-span-2 blueColor flex justify-center cursor-pointer"
                                                  onClick={() => {
                                                    setshowMoreFile(true);
                                                    setuserNameFile(
                                                      submission.user_name
                                                    );
                                                    setuserTaskIdFile(taskId);
                                                  }}
                                                >
                                                  More
                                                </p>
                                              </>
                                            ) : (
                                              <>
                                                {Object.entries(
                                                  response.file_url
                                                ).map(
                                                  ([linkId, linkData], idx) => {
                                                    if (
                                                      linkData == "" ||
                                                      !linkData
                                                    ) {
                                                      return null;
                                                    }
                                                    let itemName = linkData;
                                                    if (itemName) {
                                                      const lastSlash =
                                                        itemName.lastIndexOf(
                                                          "/"
                                                        );

                                                      if (lastSlash !== -1) {
                                                        itemName =
                                                          itemName.substr(
                                                            lastSlash + 1,
                                                            itemName.length -
                                                              lastSlash -
                                                              1
                                                          );
                                                        itemName =
                                                          itemName.includes("-")
                                                            ? itemName.substring(
                                                                itemName.indexOf(
                                                                  "-"
                                                                ) + 1
                                                              )
                                                            : itemName;
                                                      }
                                                    }
                                                    return (
                                                      <Tooltip
                                                        title={itemName ?? ""}
                                                        placement="top"
                                                        arrow
                                                      >
                                                        <DivBadge
                                                          key={idx}
                                                          className="flex flex-row items-center rounded-lg px-2 justify-center w-max cursor-pointer"
                                                        >
                                                          <MdDescription className="w-4 h-4 text-white" />
                                                          <a
                                                            href={linkData}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="flex text-xs p-1 nav-navigate"
                                                          >
                                                            <div className=" text-white">
                                                              File {idx + 1}
                                                            </div>
                                                          </a>
                                                        </DivBadge>
                                                      </Tooltip>
                                                    );
                                                  }
                                                )}
                                                <p
                                                  className="text-sm col-span-2 blueColor flex justify-center cursor-pointer"
                                                  onClick={() => {
                                                    setshowMoreFile(false);
                                                    setuserNameFile(
                                                      submission.user_name
                                                    );
                                                    setuserTaskIdFile(taskId);
                                                  }}
                                                >
                                                  Less
                                                </p>
                                              </>
                                            )
                                          ) : (
                                            Object.entries(
                                              response.file_url
                                            ).map(([linkId, linkData], idx) => {
                                              if (linkData == "" || !linkData) {
                                                return null;
                                              }
                                              let itemName = linkData;
                                              if (itemName) {
                                                const lastSlash =
                                                  itemName.lastIndexOf("/");

                                                if (lastSlash !== -1) {
                                                  itemName = itemName.substr(
                                                    lastSlash + 1,
                                                    itemName.length -
                                                      lastSlash -
                                                      1
                                                  );
                                                  itemName = itemName.includes(
                                                    "-"
                                                  )
                                                    ? itemName.substring(
                                                        itemName.indexOf("-") +
                                                          1
                                                      )
                                                    : itemName;
                                                }
                                              }
                                              return (
                                                <Tooltip
                                                  title={itemName ?? ""}
                                                  placement="top"
                                                  arrow
                                                >
                                                  <DivBadge
                                                    key={idx}
                                                    className="flex flex-row items-center rounded-lg px-2 justify-center w-max cursor-pointer"
                                                  >
                                                    <MdDescription className="w-4 h-4 text-white" />
                                                    <a
                                                      href={linkData}
                                                      target="_blank"
                                                      rel="noopener noreferrer"
                                                      className="flex text-xs p-1 nav-navigate"
                                                    >
                                                      <div className=" text-white">
                                                        File {idx + 1}
                                                      </div>
                                                    </a>
                                                  </DivBadge>
                                                </Tooltip>
                                              );
                                            })
                                          ))}
                                      </div> */}
                                      </div>
                                    </div>
                                  );
                              }
                            )
                          )}
                        <div className="w-full flex justify-center  md:w-40  px-3 sticky right-0 ml-auto cardBackgroundColor">
                          <div className="flex  items-center justify-center w-full h-full">
                            <ButtonCommonTopNew
                              className="rounded-lg py-1.5 px-3 text-xs cursor-pointer"
                              onClick={() => {
                                handleShowRespond(
                                  submission.id,
                                  submission.comment
                                );
                              }}
                            >
                              {submission.comment === null
                                ? "Comment"
                                : "Edit comment"}
                            </ButtonCommonTopNew>
                          </div>
                        </div>
                      </div>
                    </Card>
                  ))}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <>
          <div>
            <div className="flex justify-between flex-wrap py-5 px-5 md:px-8 items-center gap-3">
              {/* <ButtonCommonTopNew
              className={`rounded-lg px-5 py-2 flex items-center w-max cursor-pointer`}
              onClick={goBack}
            >
              <BiLeftArrowAlt className="w-5 h-5" />
              <h1 className="text-xs lg:text-sm">Back</h1>
            </ButtonCommonTopNew> */}
              <div
                className={`rounded-lg p-0 flex gap-1 items-center w-max cursor-pointer`}
                onClick={goBack}
              >
                <KeyboardBackspaceIcon
                  style={{ fontSize: "28px" }}
                  className=" primaryIcon"
                />
                <h1 className="text-lg blueColor font-semibold">Back</h1>
              </div>
              <div className="flex items-center gap-3 flex-wrap">
                {/* <select
                className="flex flex-row justify-center bg-gray 
                                pl-3 ml-3 pr-3 rounded-lg border-2 text-black"
                type="text"
                value={sortFieldTask}
                onChange={onChangeSort}
              >
                {dropdownOption &&
                  dropdownOption.map((option, index) => (
                    <option key={index} value={option.value}>
                      {option.label}
                    </option>
                  ))}
              </select> */}
                <Select
                  value={sortFieldTask}
                  onChange={onChangeSort}
                  displayEmpty
                  input={<OutlinedInput />}
                  SelectDisplayProps={{
                    className: "greyColor",
                  }}
                  sx={{
                    minHeight: "40px",
                    height: "40px",
                    minWidth: "140px",
                    borderRadius: "0.5rem",
                    backgroundColor: "#fff",
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "2px solid #f5f6f7", // default border
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#d1d5db", // hover border
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#d1d5db", // focus border
                    },
                    "& .MuiSelect-select": {
                      paddingY: "6px",
                      paddingX: "12px",
                    },
                    "& .MuiSelect-icon": {
                      right: "8px",
                    },
                    "& .Mui-disabled .MuiSelect-select": {
                      color: "#9ca3af", // disabled text
                    },
                  }}
                  MenuProps={{
                    disableScrollLock: true,
                  }}
                >
                  {dropdownOption &&
                    dropdownOption.map((option, index) => (
                      <MenuItem key={index} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                </Select>
                <div className="">
                  {/* <div className="flex w-full h-12 rounded-lg overflow-hidden">
                  <input
                    className="h-full w-full bg-white outline-none px-2 lg:px-3 text-black"
                    type="search"
                    placeholder="Search Student Name..."
                    onChange={handleChangeTask}
                  />
                  <SearchInput className="flex items-center justify-center text-white h-full w-12 cursor-pointer">
                    <FaSearch className="w-8 h-8 p-2" />
                  </SearchInput>
                </div> */}
                  <SearchBar
                    setSearchField={setPostSearchField}
                    placeholder="Search student"
                  />
                </div>
              </div>
            </div>
            <div className="grid pt-5 py-5 px-5 md:px-8  flex-col gap-5 items-center mb-5 backGroundColor">
              {filteredPost &&
                postSearchFiled?.length == 0 &&
                filteredPost.map((item, idx) => (
                  <div ref={(el) => (postRefs.current[item.reflection_id] = el)} key={idx}>
                    <ReflectionCards item={item} />
                  </div>
                ))}
              {searchedPost &&
                postSearchFiled?.length > 0 &&
                searchedPost.map((item, idx) => (
                  <div ref={(el) => (postRefs.current[item.reflection_id] = el)} key={idx}>
                    <ReflectionCards item={item} />
                  </div>
                ))}
              {loading && (
                <div className="grid grid-cols-1 h-10 py-3 mb-5">
                  <div className="justify-center justify-self-center">
                    <Loading active={loading} />
                  </div>
                </div>
              )}
              {hasMore && (
                <div className="grid grid-cols-1 h-14 py-3">
                  <div className="justify-center justify-self-center">
                    {/* <ButtonCommon
                    className="px-10 py-3"
                    title="Load more"
                    onClick={loadMorePost}
                  /> */}
                    <ButtonCommonTopNew
                      onClick={loadMorePost}
                      className="px-5 py-2 rounded-lg text-sm cursor-pointers"
                    >
                      Load more
                    </ButtonCommonTopNew>
                  </div>
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
}
